import landing from './landing';
import contentful from './contentful';
import custom from './custom';
import email from './email';
import user from './user';
import wizard from './wizard';

const index = {
  landing,
  contentful,
  custom,
  email,
  user,
  wizard,
};

export default index;